<template>
  <div class="container">
    <div class="project">
      <h1>{{ parseTranslation(NEW_PROJECT) }}</h1>

      <router-link to="/" class="all-surveys">{{
        translations[language][ALL_SURVEYS]
      }}</router-link>
    </div>

    <div class="header-template">
      <p>
        {{ parseTranslation(CHOOSE_TEMPLATES) }}
      </p>

      <div class="search">
        <input
          type="text"
          v-model="search"
          :placeholder="translations[language][SEARCH_TEMPLATE]"
        />

        <img class="magnifier" src="@/assets/imgs/magnifier.svg" />
      </div>
    </div>

    <div class="content-templates">
      <template-list
        :templateCategories="templateCategories"
        @selectedTemplates="
          selectedTemplates => (selectTemplateGroup = selectedTemplates)
        "
        @loader="loader => (loading = loader)"
      />
      <template-groups
        :selectTemplateGroup="selectTemplateGroup"
        :templateCategories="templateCategories"
        :loaderTemplates="loading"
      />
    </div>
  </div>
</template>

<script>
import TemplateList from './TemplateList'
import TemplateGroups from './TemplateGroups'

import * as translationFilterBox from './index.translations'

const { default: translations, ...translationKeys } = translationFilterBox

export default {
  name: 'Template',
  components: { TemplateList, TemplateGroups },
  data() {
    return {
      translations,
      ...translationKeys,
      search: '',
      templateCategories: [],
      selectTemplateGroup: [],
      loading: false,
    }
  },

  watch: {
    search() {
      this.$router.push({
        query: this.query(this.search),
      })
    },
  },

  methods: {
    getInfoTemplate() {
      this.templateCategories = JSON.parse(sessionStorage.getItem('infoCreateTemplate'))
    },
    query(q) {
      return {
        ...this.$route.query,
        _q: q,
      }
    },
  },
  created() {
    this.getInfoTemplate()
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding: 30px 10px 20px;
}

.project {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid $white;
  padding-bottom: 20px;
  height: 100%;
  h1 {
    @include tipography(20);
  }
  .all-surveys {
    display: flex;
    align-items: center;
    @include tipography(14);
    &::before {
      content: '';
      display: block;
      width: 15px;
      height: 15px;
      background: url(../../assets/imgs/back.svg) no-repeat center;
      margin-right: 5px;
    }
    .light & {
      color: $gray-4;
      &::before {
        background: url(../../assets/imgs/back_dark.svg) no-repeat center;
      }
    }
  }
  .light & {
    border-bottom: 0.5px solid $gray-5;
    h1 {
      color: $gray-6;
    }
  }
}

.header-template {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 50px;
  p {
    @include tipography(14);
    color: $white;
    .light & {
      color: $gray-2;
    }
  }
  .search {
    position: relative;
    width: 250px;
    @include black-input;
    img {
      position: absolute;
      right: 10px;
      margin-left: 10px;
      width: 15px;
      height: 15px;
    }
  }
}

.content-templates {
  margin-top: 50px;
  display: flex;
}

@media (max-width: 768px) {
  .header-template {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 50px;
    p {
      @include tipography(14);
      color: $white;
      .light & {
        color: $gray-2;
      }
    }
    .search {
      margin-top: 20px;
    }
  }

  .content-templates {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>
